var fade_in = ( function( $ ) {

	var controller = null;

	var _init = function() {
		$( 'html' ).removeClass( 'no-js' );
		controller = new ScrollMagic.Controller();

		add_handlers( $( '.fade-in' ) );
	};

	var add_handlers = function( $object ) {
		$object.each( function() {

			if ( $( this ).hasClass( 'fade-in' ) ) {
				var object = $( this ).get(0);

				new ScrollMagic.Scene( {
					triggerElement: object,
					reverse: false,
					triggerHook: 0.9
				} ).on('start', function () {
					_start_fade_in(object)
				} ).addTo(controller);
			}
		} );
	};

	var _start_fade_in = function( object ) {
		$( object ).addClass( 'done' );
	};

	$( document ).ready( _init );

	return {
		add_handlers: add_handlers
	};
	
} ) ( jQuery );

module.exports = fade_in;